import { TreeItem } from '@material-ui/lab'
import React from 'react'
import PropTypes from 'prop-types'
import { fade, Typography, withStyles } from '@material-ui/core';
import { TransitionComponent } from './TreeViewUtils';
import { useTreeItemStyles } from './CommonStyles';

const StyledTreeItem = withStyles((theme) => ({
    iconContainer: {
        '& .close': {
            opacity: 0.3,
        },
    },
    group: {
        marginLeft: 7,
        paddingLeft: 18,
        borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`,
    },
}))((props) => {
    const classes = useTreeItemStyles();
    const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, onClickFunction, ...other } = props;
    return (
        <TreeItem
            onClick={onClickFunction}
            label={
                <div className={classes.labelRoot}>
                    <LabelIcon color="inherit" className={classes.labelIcon} />
                    <Typography variant="body2" className={classes.labelText}>
                        {labelText}
                    </Typography>
                    <Typography variant="caption" color="inherit">
                        {labelInfo}
                    </Typography>
                </div>
            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': bgColor,
            }}
            TransitionComponent={TransitionComponent}
            {...other}
        />)
});

StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
    onClickFunction: PropTypes.func
};

export default StyledTreeItem
